<script>
  import { onMount } from 'svelte';
  import SEOHead from '$lib/components/SEOHead.svelte';
  import { page } from '$app/stores';

  $: lang = $page.params.lang;
  $: policyId = lang === 'it' ? '7995230' : '47472348';
  $: iubendaUrl = `https://www.iubenda.com/privacy-policy/${policyId}/cookie-policy`;

  onMount(() => {
    const s = document.createElement('script');
    s.src = 'https://cdn.iubenda.com/iubenda.js';
    document.body.appendChild(s);
  });
</script>

<SEOHead
  title="Cookie Policy - Auting"
  description="Informativa sui cookie di Auting: scopri come utilizziamo i cookie per migliorare la tua esperienza."
  pageName="cookie-policy"
/>

<main class="legal-page">
  <div class="content iub-content-wrapper">
    <a
      href={iubendaUrl}
      class="iubenda-nostyle iubenda-noiframe iubenda-embed iub-legal-only iub-no-markup iub-body-embed"
      title="Cookie Policy"
    >
      Cookie Policy
    </a>
  </div>
</main>

<style>

  .legal-page {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .header {
    padding: 3rem 2rem;
    background-color: var(--surface-container);
    text-align: center;
    margin-bottom: 2rem;
  }

  .header h1 {
    margin: 0;
    font-size: 2.5rem;
    color: var(--on-surface);
  }

  .content {
    padding: 50px 2rem 3rem;
    max-width: 1200px;
    margin: 0 auto;
    width: 100%;
  }

  /* Global styles for iubenda embedded content */
  :global(.iub-content-wrapper .iub_content),
  :global(.iub-content-wrapper .iub_content *) {
    font-family: var(--font-body, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif);
    color: var(--on-surface);
    line-height: 1.6;
    text-decoration: none !important;
    background: none !important;
    border: none !important;
  }

  :global(.iub-content-wrapper #iub-pp-container),
  :global(.iub-content-wrapper .iub_container),
  :global(.iub-content-wrapper .iubenda_fluid_policy),
  :global(.iub-content-wrapper .iubenda_embed_policy),
  :global(.iub-content-wrapper .iub_base_container) {
    background: transparent !important;
    border: none !important;
    padding: 0 !important;
    box-shadow: none !important;
  }

  :global(.iub-content-wrapper .iub_content h1),
  :global(.iub-content-wrapper .iub_content h2),
  :global(.iub-content-wrapper .iub_content h3),
  :global(.iub-content-wrapper .iub_content h4),
  :global(.iub-content-wrapper .iub_content h5),
  :global(.iub-content-wrapper .iub_content h6) {
    font-family: var(--font-heading);
    color: var(--on-surface);
    margin-top: 1.5em;
    margin-bottom: 0.5em;
    font-weight: 600;
    text-decoration: none !important;
    border: none !important;
  }

  :global(.iub-content-wrapper .iub_content h1) {
    font-size: 2em;
  }

  :global(.iub-content-wrapper .iub_content h2) {
    font-size: 1.75em;
  }

  :global(.iub-content-wrapper .iub_content h3) {
    font-size: 1.5em;
  }

  :global(.iub-content-wrapper .iub_content h4) {
    font-size: 1.25em;
  }

  :global(.iub-content-wrapper .iub_content p) {
    margin: 1em 0;
    text-decoration: none !important;
    border-bottom: none !important;
    border-top: none !important;
  }

  :global(.iub-content-wrapper .iub_content ul),
  :global(.iub-content-wrapper .iub_content ol) {
    margin: 1em 0 !important;
    padding-left: 2em !important;
    list-style: disc !important;
  }

  :global(.iub-content-wrapper .iub_content li) {
    margin: 0.5em 0 !important;
    display: list-item !important;
    list-style: disc !important;
  }

  :global(.iub-content-wrapper .iub_content a) {
    color: var(--color-theme-1, #FF6B6B);
    text-decoration: none;
  }

  :global(.iub-content-wrapper .iub_content a:hover) {
    text-decoration: underline;
  }

  :global(.iub-content-wrapper .iub_content strong),
  :global(.iub-content-wrapper .iub_content b) {
    font-weight: 600;
  }

  :global(.iub-content-wrapper .iub_content em),
  :global(.iub-content-wrapper .iub_content i) {
    font-style: italic;
  }

  :global(.iub-content-wrapper .iub_content table) {
    width: 100%;
    border-collapse: collapse;
    margin: 1.5em 0;
  }

  :global(.iub-content-wrapper .iub_content th),
  :global(.iub-content-wrapper .iub_content td) {
    border: 1px solid var(--surface-300, #e0e0e0);
    padding: 0.75em;
    text-align: left;
  }

  :global(.iub-content-wrapper .iub_content th) {
    background-color: var(--surface-container, #f5f5f5);
    font-weight: 600;
  }

  :global(.iub-content-wrapper .iub_content code) {
    background-color: var(--surface-container, #f5f5f5);
    padding: 0.2em 0.4em;
    border-radius: 4px;
    font-family: 'Monaco', 'Courier New', monospace;
    font-size: 0.9em;
  }

  :global(.iub-content-wrapper .iub_content pre) {
    background-color: var(--surface-container, #f5f5f5);
    padding: 1em;
    border-radius: 8px;
    overflow-x: auto;
    margin: 1em 0;
  }

  :global(.iub-content-wrapper .iub_content blockquote) {
    border-left: 4px solid var(--color-theme-1, #FF6B6B);
    padding-left: 1em;
    margin-left: 0;
    color: var(--on-surface-variant, #666);
  }

  @media (max-width: 768px) {
    .header {
      padding: 2rem 1rem;
      margin-bottom: 1.5rem;
    }

    .header h1 {
      font-size: 1.75rem;
    }

    .content {
      padding: 50px 1rem 2rem;
    }

    :global(.iub-content-wrapper .iub_content h1) {
      font-size: 1.5em;
    }

    :global(.iub-content-wrapper .iub_content h2) {
      font-size: 1.25em;
    }

    :global(.iub-content-wrapper .iub_content h3) {
      font-size: 1.1em;
    }
  }
</style>
